// Tek kaynak: arayüzdeki klasör id'leri <-> cPanel IMAP klasör adları.
// (Daha önce bu tablo Sidebar/MailList/MailView içinde kopyalanmıştı.)
export const FOLDERS = [
  { id: 'inbox', name: 'Gelen kutusu', imap: 'INBOX', icon: 'Inbox' },
  { id: 'starred', name: 'Yıldızlı', imap: 'INBOX', icon: 'Star', virtual: true },
  { id: 'sent', name: 'Gönderilenler', imap: 'INBOX.Sent', icon: 'Send' },
  { id: 'drafts', name: 'Taslaklar', imap: 'INBOX.Drafts', icon: 'FileText' },
  // Zamanlanmış: IMAP klasörü değil, veritabanından gelen "göndermeyi zamanla" listesi
  { id: 'scheduled', name: 'Zamanlanmış', imap: null, icon: 'Clock', virtual: true },
  { id: 'archive', name: 'Arşiv', imap: 'INBOX.Archive', icon: 'Archive' },
  { id: 'spam', name: 'İstenmeyen', imap: 'INBOX.spam', icon: 'ShieldAlert' },
  { id: 'trash', name: 'Çöp kutusu', imap: 'INBOX.Trash', icon: 'Trash2' },
];

const IMAP_ALIASES = { junk: 'INBOX.Junk' };

export const getImapFolder = (id) => {
  if (typeof id === 'string' && id.startsWith('label:')) return 'INBOX'; // etiket görünümü gelen kutusunda süzer
  const folder = FOLDERS.find((f) => f.id === id);
  return folder ? folder.imap || 'INBOX' : IMAP_ALIASES[id] || 'INBOX';
};

export const getFolderTitle = (id) => FOLDERS.find((f) => f.id === id)?.name || 'Gelen kutusu';
